let thisElement = null;
let isAmountAdjusting = false;
let isLoadingAdjuster = false;
let isFistTimePageLoad = true;
let pendingUpdates = new Map();
let isAmountAdjust = false; 

$(document).ready(function () {
    window.veriff = {
        result: null,
    };

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    $(".appoinment_icon_wrapp .appoinment_contant_wrapp.without_homepage_header a").click(function () {
        setCookie("appointmentform", "appointmentform", 1);
    });
    $(".main_claculator-right-part .right-side-bottom a.btn").click(function () {
        setCookie("appointmentform", "appointmentform", 1);
    });
    $(".custom-first-menu-here").click(function () {
        $(this).parents("li.slide-nav__item").toggleClass("active-menu");
    });

    jQuery.getJSON("/cart.js", function (cart) {
        var original_price = cart.total_price,
            total_goal = $(".sidebar_progress_bar").attr("data-goal"),
            final_result = original_price / 100;
        if (final_result >= total_goal) {
            $("span.minus_val").hide();
            $(".free_shipping_text").show();
        } else if (final_result < total_goal) {
            $(".free_shipping_text").hide();
        }
    });

    $("ul.site-nav li.site-nav--has-dropdown").mouseleave(function () {
        $("body").removeClass("on_header_hover");
    });
    $("ul.site-nav li.site-nav--has-dropdown").mouseenter(function () {
        $("body").addClass("on_header_hover");
    });

    $(document).on("change", "input[type=date]", function () {
        var data_value_get = $(this).val();
        if (data_value_get !== "") {
            $(this).removeClass("placeholder_shown");
            $(this).addClass("placeholder_hide");
        } else {
            $(this).addClass("placeholder_shown");
            $(this).removeClass("placeholder_hide");
        }
    });

    $(document).on("focus", "input[type=date]", function () {
        var data_value_get = $(this).val();
        if (data_value_get !== "") {
            $(this).removeClass("placeholder_shown");
            $(this).addClass("placeholder_hide");
        } else {
            $(this).addClass("placeholder_shown");
            $(this).removeClass("placeholder_hide");
        }
    });

var disabledDates = [ "2024-07-29", "2024-07-30", "2024-07-31", "2024-08-01", "2024-08-02", "2024-08-03", "2024-08-04", "2024-08-05", "2024-08-06", "2024-08-07", "2024-08-08", "2024-08-09", "2024-08-10", "2024-08-11", "2024-08-12", "2024-08-13", "2024-08-14", "2024-08-15", "2024-08-16", "2024-08-17", ];

    // $("#datepic_client_date, #second_datepic_client_date").datepicker({
    //     minDate: new Date(),
    //     dateFormat: "dd-mm-yy",

    //     beforeShowDay: function (date) {
    //         var dayOfWeek = date.getDay();
    //         var formattedDate = $.datepicker.formatDate("dd-mm-yy", date);
    //         var today = new Date();
    //         var isToday = formattedDate === $.datepicker.formatDate("dd-mm-yy", today);
    //         var isDisabledDate = disabledDates.indexOf(formattedDate) !== -1;
    //         var isWeekend = dayOfWeek === 0 || dayOfWeek === 1;
    //         /* ---------------------------------------
    //            NEW : Agency Holiday Check
    //         --------------------------------------- */
    //         var selectedAgency = $("#agency-id").val();
    //         if (selectedAgency) {
    //             var holiday = isAgencyClosed(selectedAgency, formattedDate);
    //             if (holiday.status) {
    //                 console.log("🚫 Holiday:", selectedAgency, formattedDate);
    //                 return [false, "disabled", "Agency Closed"];
    //             }
    //         }
    //         /* --------------------------------------- */
    //         if (
    //             (isToday && isWeekend) ||
    //             isDisabledDate ||
    //             isWeekend
    //         ) {
    //             return [false, "disabled"];
    //         }
    //         return [true, ""];
    //     },
    //     onSelect: function (dateText) {
    //         var selectedDate = $(this).datepicker("getDate");
    //         var dayOfWeek = selectedDate.getDay();
    //         // Move Sunday/Monday to next valid day
    //         if (dayOfWeek === 0 || dayOfWeek === 1) {
    //             selectedDate.setDate(
    //                 selectedDate.getDate() + (dayOfWeek === 0 ? 2 : 1)
    //             );
    //             $(this).datepicker("setDate", selectedDate);
    //         }
    //         // Format as YYYY-MM-DD
    //         var formattedDate = $.datepicker.formatDate(
    //             "yy-mm-dd",
    //             selectedDate
    //         );
    //         // Update the hidden input in THIS form only
    //         $(this)
    //             .closest("form")
    //             .find('input[name="client_date"]')
    //             .val(formattedDate);

    //         console.log("Selected Date:", formattedDate);
    //     }
    // });

    $("#datepic_client_date, #second_datepic_client_date").datepicker({

    minDate: new Date(),

    // What user sees
    dateFormat: "dd-mm-yy",

    beforeShowDay: function (date) {

        var dayOfWeek = date.getDay();

        // ==========================================
        // INTERNAL DATE FORMAT
        // IMPORTANT:
        // Use yy-mm-dd for holiday / disabled date logic
        // ==========================================

        var formattedDate = $.datepicker.formatDate(
            "yy-mm-dd",
            date
        );

        var today = new Date();

        var todayFormatted = $.datepicker.formatDate(
            "yy-mm-dd",
            today
        );

        var isToday = formattedDate === todayFormatted;

        // Your disabledDates array should contain:
        // 2024-07-29
        // 2024-07-30
        // etc.
        var isDisabledDate =
            disabledDates.indexOf(formattedDate) !== -1;

        // Sunday = 0
        // Monday = 1
        var isWeekend =
            dayOfWeek === 0 || dayOfWeek === 1;


        // ==========================================
        // AGENCY HOLIDAY CHECK
        // ==========================================

        var selectedAgency = $("#agency-id").val();

        if (selectedAgency) {

            var holiday = isAgencyClosed(
                selectedAgency,
                formattedDate
            );

            if (holiday.status) {

                console.log(
                    "🚫 Holiday:",
                    selectedAgency,
                    formattedDate
                );

                return [
                    false,
                    "disabled",
                    "Agency Closed"
                ];
            }
        }


        // ==========================================
        // DISABLED DATE / WEEKEND
        // ==========================================

        if (
            isDisabledDate ||
            isWeekend
        ) {

            return [
                false,
                "disabled"
            ];
        }


        return [
            true,
            ""
        ];
    },


    // ==========================================
    // DATE SELECTED
    // ==========================================

    onSelect: function (dateText) {

        console.log(
            "Datepicker selected:",
            dateText
        );


        // ==========================================
        // GET REAL DATE OBJECT FROM DATEPICKER
        // DO NOT USE new Date(dateText)
        // ==========================================

        var selectedDate = $(this).datepicker("getDate");

        if (!selectedDate) {

            console.error(
                "Could not get selected date:",
                dateText
            );

            return;
        }


        // ==========================================
        // CHECK DAY
        // ==========================================

        var dayOfWeek = selectedDate.getDay();


        // Sunday / Monday -> next valid day
        if (dayOfWeek === 0 || dayOfWeek === 1) {

            selectedDate.setDate(
                selectedDate.getDate() +
                (dayOfWeek === 0 ? 2 : 1)
            );

            $(this).datepicker(
                "setDate",
                selectedDate
            );
        }


        // ==========================================
        // HIDDEN INPUT FORMAT
        // YYYY-MM-DD
        // ==========================================

        var formattedDate = $.datepicker.formatDate(
            "yy-mm-dd",
            selectedDate
        );


        console.log(
            "Selected Date:",
            formattedDate
        );


        // ==========================================
        // UPDATE ONLY CURRENT FORM
        // ==========================================

        var currentForm = $(this).closest("form");


        currentForm
            .find('input[name="client_date"]')
            .val(formattedDate);


        // ==========================================
        // REMOVE ERROR FOR CURRENT DATE ONLY
        // ==========================================

        var currentDateWrapper = $(this).closest(
            ".date_main-wrapp, .date_main-wrappsecond"
        );


        currentDateWrapper
            .find(".date-error-message")
            .hide();


        currentDateWrapper
            .removeClass("mobile-error-show");


        console.log(
            "Hidden client_date:",
            currentForm
                .find('input[name="client_date"]')
                .val()
        );
    }

});
    // ============================================
    // CART ADJUSTMENT LOGIC
    // ============================================
    adjustAmount(true);
    $(document).on("CartDrawer:open drawerOpen ajaxProduct:added", () => {
        adjustAmount(false);
    });

    $(document).on("cart:updated", () => {
        console.log("cart:updated");
        adjustAmount(false);
        if (!isFistTimePageLoad) {
            setTimeout(() => {
                window.location.reload();
            }, 500);
        }
    });

    // Handle typing in the adjust value input
    $(".adjust-value").on("keyup", function (e) {
        isAmountAdjusting = true;
    });

    // Only update attributes on change, do NOT call change.js yet
    $(".adjust-value").on("change", function (e) {
        const $input = $(this);
        const itemKey = $input.parents(".cart__item").data("key");
        isAmountAdjusting = true;
        let newVal = parseFloat($input.val().replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1"));
        let itemAmount = parseFloat($input.data("value"));
        let symbol = newVal > itemAmount ? "+" : "-";
        let remainAmount = Math.abs(itemAmount - newVal);
        // Update the data attributes
        $input.attr("data-adjust_symbol", symbol);
        $input.attr("data-adjust_amount", remainAmount);
        // Store the current element data
        thisElement = {
            symbol: symbol,
            remainAmount: remainAmount,
            id: $input.data("id"),
            qty: $input.parents(".cart__item").find(".js-qty__num").val(),
        };
        // Store in pending updates with all necessary data
        pendingUpdates.set(itemKey, {
            key: itemKey,
            $input: $input,
            quantity: Number($input.parents(".cart__item").find(".js-qty__num").val() || 1),
            adjustAmount: remainAmount,
            adjustSymbol: symbol,
        });
        // Update the display immediately (visual feedback only)
        adjustAmount(false);
        console.log("Price changed, waiting for blur/click outside to save...");
    });
    // Call change.js only when input loses focus
    $(".adjust-value").on("blur", async function (e) {
        const $input = $(this);
        const itemKey = $input.parents(".cart__item").data("key");
        if (pendingUpdates.has(itemKey)) {
            console.log("Input blurred, updating cart...");
            isLoadingAdjuster = true;
            await updateSingleLineItem($input);
            pendingUpdates.delete(itemKey);
            isAmountAdjusting = false;
            isLoadingAdjuster = false;
            adjustAmount(false);
        }
    });

    // Checkout button handler
    $(document).on("click", "#myBtn", async function (e) {
        e.preventDefault();
        $(".customer_exist").removeClass("required");
        if ($(".customer_exist").length > 0 && $(".customer_exist").val() == "") {
            $(".customer_exist").addClass("required").focus();
            return;
        }
        // Wait for any pending updates to complete
        if (pendingUpdates.size > 0) {
            await updateAllPendingLineItems();
        }
        initViriffCheckout();
    });

    $(document).on("click", "#myModalClose", function (e) {
        $("#myModal").hide();
    });

    // Call change.js when clicking outside the input
    $(document).on("click", async function (e) {
        if (!$(e.target).hasClass("adjust-value") && !$(e.target).closest(".adjust-value").length) {
            if (pendingUpdates.size > 0) {
                console.log("Clicked outside, updating all pending items...");
                await updateAllPendingLineItems();
            }
        }
    });

    // Also update when switching to another adjust-value input
    $(document).on("focus", ".adjust-value", async function (e) {
        const currentKey = $(this).parents(".cart__item").data("key");
        if (pendingUpdates.size > 0) {
            const itemsToUpdate = Array.from(pendingUpdates.values()).filter(item => item.key !== currentKey);
            if (itemsToUpdate.length > 0) {
                console.log("Switching to another input, updating previous item...");
                isLoadingAdjuster = true;
                for (const itemData of itemsToUpdate) {
                    await updateSingleLineItemFromData(itemData);
                    pendingUpdates.delete(itemData.key);
                }
                isLoadingAdjuster = false;
                adjustAmount(false);
            }
        }
    });
});

function addJsScript(src) {
    var script = document.createElement("script");
    script.src = src;
    document.head.appendChild(script);
}

// ============================================
// Update a single line item from input element
// ============================================
async function updateSingleLineItem($input) {
    const itemKey = $input.parents(".cart__item").data("key");
    const quantity = Number($input.parents(".cart__item").find(".js-qty__num").val() || 1);
    const adjustAmt = $input.attr("data-adjust_amount");
    const adjustSymbol = $input.attr("data-adjust_symbol");
    try {
        console.log("Calling /cart/change.js for item:", itemKey);
        const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                id: itemKey,
                quantity: quantity,
                properties: {
                    _adjust_amount: adjustAmt,
                    _adjust_symbol: adjustSymbol,
                },
            }),
        });
        const result = await response.json();
        if (result.status === "bad_request") {
            console.error("Cart update error:", result.message);
            return null;
        }
        console.log("Item updated successfully:", result);
        return result;
    } catch (error) {
        console.error("Error updating item:", error);
        return null;
    }
}

// ============================================
// Update a single line item from stored data
// ============================================
async function updateSingleLineItemFromData(itemData) {
    try {
        console.log("Calling /cart/change.js for item:", itemData.key);
        const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                id: itemData.key,
                quantity: itemData.quantity,
                properties: {
                    _adjust_amount: itemData.adjustAmount,
                    _adjust_symbol: itemData.adjustSymbol,
                },
            }),
        });
        const result = await response.json();
        if (result.status === "bad_request") {
            console.error("Cart update error:", result.message);
            return null;
        }
        console.log("Item updated successfully:", result);
        return result;
    } catch (error) {
        console.error("Error updating item:", error);
        return null;
    }
}

// ============================================
// Update all pending line items
// ============================================
async function updateAllPendingLineItems() {
    if (pendingUpdates.size === 0) return;
    isLoadingAdjuster = true;
    isAmountAdjusting = true;
    console.log("Updating", pendingUpdates.size, "pending items...");
    for (const [key, itemData] of pendingUpdates.entries()) {
        await updateSingleLineItemFromData(itemData);
    }
    pendingUpdates.clear();
    isAmountAdjusting = false;
    thisElement = null;
    isLoadingAdjuster = false;
    adjustAmount(false);
    console.log("All pending updates completed");
}

// ============================================
// CHECKOUT FUNCTION - FIXED
// ============================================
async function initViriffCheckout() {
    let oldBtnText = $("#myBtn").html();
    $("#myBtn").attr("disabled", "true").html("Please wait...");
    await fetch("/cart/update.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            attributes: {
                "Customers email address": $("#client-email").val(),
            },
        }),
    });
    // Wait for all pending updates first
    if (pendingUpdates.size > 0) {
        await updateAllPendingLineItems();
    }
    // Still adjusting? retry
    if (isAmountAdjusting) {
        setTimeout(() => {
            initViriffCheckout();
        }, 500);
        return false;
    }
    // FIXED: Re-run adjustAmount to correctly refresh isAmountAdjust global flag
    adjustAmount(false);
    if (
        ShopifyAnalytics.meta.page.customerId
        && (isAmountAdjust || $(".shipping-line-item--radio input[type='radio']:checked").val() == "Click and collect")
    ) {
        $.getJSON("/cart.js", function (data) {
            $.post("https://goldunion.codevibez.com/veriff/index.php", {
                shop: "goldunion-uk.myshopify.com",
                customer: ShopifyAnalytics.meta.page.customerId ?? "",
                cart: data,
                email: $("#client-email").val(),
                shipping: {
                    name: $(".shipping-line-item--radio input[type='radio']").length > 0
                        ? $(".shipping-line-item--radio input[type='radio']:checked").val()
                        : "",
                    agent: $("#agency-id").length > 0 ? $("#agency-id").val() : "",
                },
            }, (result) => {
                window.location = result.order.invoice_url;
            });
        });
    } else {
        window.location = window.location.origin + "/checkout";
    }
}

// ============================================
// ADJUST AMOUNT DISPLAY - FIXED (early return bug removed)
// ============================================
function adjustAmount(updateValue) {
    let addedAmount = 0;
    isAmountAdjust = false; // FIXED: Now correctly sets the global variable
    if ($(".adjust-value").length > 0) {
        isFistTimePageLoad = false;
        $(".adjust-value").each(function () {
            let symbol = $(this).attr("data-adjust_symbol") || "";
            let amount = parseFloat($(this).attr("data-adjust_amount")) || 0;
            let itemAmount = parseFloat($(this).attr("data-value")) || 0;
            let amt = 0;
            if (amount > 0) {
                isAmountAdjust = true;
            }
            let qty = parseInt($(this).parents(".cart__item").find(".js-qty__num").val()) || 1;
            if (symbol == "+") {
                amt += amount;
                itemAmount += amount;
            } else if (symbol == "-") {
                amt -= amount;
                itemAmount -= amount;
            }
            addedAmount += amt * qty;
            if ($(".cart__drawer-form").length > 0) {
                $(this).parents(".cart__item").find(".pricediv").html(
                    theme.Currency.formatMoney(itemAmount * 100),
                );
            }
            if (updateValue) $(this).val(itemAmount);
        });
        $("#main--shipping-div").hide();
        if (isAmountAdjust) {
            $("#main--shipping-div").show();
        }
        let cartTotalItem = $(".main__cart__item-sub--subtotal");
        let total = theme.Currency.formatMoney(
            parseInt(cartTotalItem.data("total")) + addedAmount * 100,
        );
        // FIXED: Remove old element first
        $(".main__cart__item-sub--subtotal-adjust").remove();
        // FIXED: Check if container exists BEFORE appending, no early return bug
        if ($(".cart__item--subtotal--adjust").length > 0) {
            $(".cart__item--subtotal--adjust").append(
                "<div class=\"main__cart__item-sub--subtotal-adjust\"></div>",
            );
            $(".main__cart__item-sub--subtotal--adjust").hide();
            $(".main__cart__item-sub--subtotal-adjust").html(total);
            return;
        }
        if ($(".cart__drawer-form").length > 0) {
            $(".cart__drawer-form .main__cart__item-sub--subtotal .wholesale-cart-total span").html(total);
            return;
        }
    }
}
// ============================================
// CONTACT FORM VALIDATION AND SUBMISSION
// ============================================
function validatePhoneNumber(input_str) {
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return re.test(input_str);
}

let agencyClosures = [];
const csvUrl = window.agencyCsvUrl;
fetch(csvUrl)
    .then(response => {
        if (!response.ok) {
            throw new Error("HTTP " + response.status);
        }
        return response.text();
    })
    .then(csv => {
        const rows = csv.trim().split(/\r?\n/);
        // Detect separator automatically
        const separator = rows[0].includes(";") ? ";" : ",";
        // Remove header
        rows.shift();
        agencyClosures = rows
            .filter(row => row.trim() !== "")
            .map(row => {
                const cols = row.split(separator);

                return {
                    "Agence": (cols[0] || "").trim(),
                    "Date Fermeture": (cols[1] || "").trim(),
                    "Date réouverture": (cols[2] || "").trim(),
                };
            });
        // console.log("Agency Closures:", agencyClosures.length);
        // console.table(agencyClosures);
    })
    .catch(console.error);
function convertFrenchDate(value) {
    if (!value) return null;
    value = value.toString().trim();
    // dd-mm-yy  (20-08-26)
    if (/^\d{2}-\d{2}-\d{2}$/.test(value)) {
        const p = value.split("-");
        return new Date(
            2000 + parseInt(p[2], 10), // 26 -> 2026
            parseInt(p[1], 10) - 1,
            parseInt(p[0], 10),
        );
    }
    // yyyy-mm-dd
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const p = value.split("-");
        return new Date(
            parseInt(p[0], 10),
            parseInt(p[1], 10) - 1,
            parseInt(p[2], 10),
        );
    }
    // dd/mm/yyyy
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
        const p = value.split("/");
        return new Date(
            parseInt(p[2], 10),
            parseInt(p[1], 10) - 1,
            parseInt(p[0], 10),
        );
    }
    return new Date(value);
}
function parseBookingDate(value) {
    if (!value) return null;
    value = value.trim();
    // yyyy-mm-dd
    if (value.indexOf("-") > -1) {
        const p = value.split("-");
        return new Date(
            parseInt(p[0], 10),
            parseInt(p[1], 10) - 1,
            parseInt(p[2], 10),
        );
    }
    // dd/mm/yyyy
    if (value.indexOf("/") > -1) {
        const p = value.split("/");
        return new Date(
            parseInt(p[2], 10),
            parseInt(p[1], 10) - 1,
            parseInt(p[0], 10),
        );
    }
    return new Date(value);
}
function normalizeAgency(name) {
    return name
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/-/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}
function isAgencyClosed(agency, bookingDate) {
    if (!agency || !bookingDate) {
        return {
            status: false,
        };
    }
    const selectedAgency = normalizeAgency(agency);
    // bookingDate format: yyyy-mm-dd
    const selectedDate = $.datepicker.parseDate("yy-mm-dd", bookingDate);
    selectedDate.setHours(0, 0, 0, 0);
    const selectedTime = selectedDate.getTime();
    for (const row of agencyClosures) {
        if (!row["Agence"]) continue;
        if (normalizeAgency(row["Agence"]) !== selectedAgency) continue;
        const closeDate = convertFrenchDate(row["Date Fermeture"]);
        const reopenDate = convertFrenchDate(row["Date réouverture"]);
        if (!closeDate || !reopenDate) continue;
        closeDate.setHours(0, 0, 0, 0);
        // Reopen the next day
        reopenDate.setDate(reopenDate.getDate() + 1);
        reopenDate.setHours(0, 0, 0, 0);
        const closeTime = closeDate.getTime();
        const reopenTime = reopenDate.getTime();
        // console.log("================================");
        // console.log("Agency :", row["Agence"]);
        // console.log("Booking:", selectedDate);
        // console.log("Closed :", closeDate);
        // console.log("Reopen :", reopenDate);
        if (selectedTime >= closeTime && selectedTime < reopenTime) {
            //   console.log("🚫 CLOSED");
            return {
                status: true,
                close: closeDate,
                reopen: reopenDate,
                row: row,
            };
        }
    }
    //   console.log("✅ AVAILABLE");
    return {
        status: false,
    };
}
/* ==========================================================
   PHONE HELPERS (UK)
========================================================== */

/* Allow only digits, + space . - ( ) while typing (no length cap) */
$(document).on('input', '.custom_mobile_fileds', function () {
    this.value = this.value.replace(/[^\d+\s.\-()]/g, '');
});

function getItiInstance(input) {
    return (window.intlTelInputGlobals && intlTelInputGlobals.getInstance)
        ? intlTelInputGlobals.getInstance(input)
        : null;
}

/**
 * Normalizes and validates the phone number.
 * Returns { valid: bool, e164: '+447700900123', dial: '+44' }
 */
function validatePhoneInput($form) {

    var DEFAULT_DIAL = '+44';

    var input  = $form.find('.custom_mobile_fileds')[0];
    var result = { valid: false, e164: '', dial: '' };

    if (!input) return result;

    // Strip spaces, dots, dashes, parentheses
    var d = String(input.value || '').replace(/[\s.\-()]/g, '');

    // Only digits and an optional leading "+"
    if (!d || !/^\+?\d+$/.test(d)) return result;

    // 0044... -> +44...
    if (d.indexOf('00') === 0) d = '+' + d.slice(2);

    var iti  = getItiInstance(input);
    var dial = ($form.find('.iti__selected-dial-code').text() || '').trim();

    if (iti && iti.getSelectedCountryData && iti.getSelectedCountryData().dialCode) {
        dial = '+' + iti.getSelectedCountryData().dialCode;
    }

    if (!dial) dial = DEFAULT_DIAL;

    // +44 (0)7700... -> +44 7700...  (also +33 (0)6...)
    if ((dial === '+44' || dial === '+33') && d.indexOf(dial + '0') === 0) {
        d = dial + d.slice(dial.length + 1);
    }

    /* ---- Preferred path: intl-tel-input with utils loaded ---- */
    if (iti && window.intlTelInputUtils && typeof iti.isValidNumber === 'function') {

        iti.setNumber(d);

        if (iti.isValidNumber()) {
            result.valid = true;
            result.e164  = iti.getNumber();
            result.dial  = '+' + iti.getSelectedCountryData().dialCode;
        }

        return result;
    }

    /* ---- Fallback without utils ---- */
    var national;

    if (d.charAt(0) === '+') {
        if (d.indexOf(dial) !== 0) return result;
        national = d.slice(dial.length);
    } else {
        national = d;
    }

    if (dial === '+39') {
        // Italy keeps the leading 0 of landlines
        if (!/^(3\d{8,9}|0\d{5,10})$/.test(national)) return result;

    } else if (dial === '+44') {
        // UK: drop trunk 0, then 9-10 digits (e.g. 07700 900123 -> 7700900123)
        if (national.charAt(0) === '0') national = national.slice(1);
        if (!/^[1-9]\d{8,9}$/.test(national)) return result;

    } else if (dial === '+33') {
        if (national.charAt(0) === '0') national = national.slice(1);
        if (!/^[1-9]\d{8}$/.test(national)) return result;

    } else {
        if (national.charAt(0) === '0') national = national.slice(1);
        if (!/^\d{6,12}$/.test(national)) return result;
    }

    result.valid = true;
    result.e164  = dial + national;
    result.dial  = dial;

    return result;
}


function sendContactFormAction(formSelector) {

    console.log("=================================");
    console.log("🟢 SUBMIT BUTTON CLICKED");
    console.log("Form selector:", formSelector);
    console.log("=================================");


    var $form = $(formSelector);

    /*
     * CURRENT FORM SUBMIT BUTTON
     * Only lock the button belonging to this form.
     */
    var $submitButton =
        $form.find(".brn-contact-form-submit");


    /*
     * PREVENT DUPLICATE SUBMISSION
     */

    // Already successfully submitted
    if ($submitButton.attr("data-booking-submitted") === "true") {

        console.log("⚠️ Booking already submitted. Stopping duplicate submission.");

        return false;
    }

    // API request already running
    if ($submitButton.attr("data-booking-submitting") === "true") {

        console.log("⚠️ Booking submission already in progress.");

        return false;
    }


    var form = $form[0];


    // ==========================================
    // HIDE ALL CUSTOM ERROR MESSAGES
    // ==========================================

    $form.find(
        '.agency-error-message, ' +
        '.motif-error-message, ' +
        '.name-error-message, ' +
        '.lastname-error-message, ' +
        '.email-error-message, ' +
        '.contact-error-message, ' +
        '.address-error-message, ' +
        '.date-error-message, ' +
        '.time-error-message, ' +
        '.privacy-error-message'
    ).hide();


    $form.find(
        '.name_main-wrapp, ' +
        '.lastname_main-wrapp, ' +
        '.mobile_label_input, ' +
        '.date_main-wrapp, ' +
        '.date_main-wrappsecond, ' +
        '.time_main-wrapp'
    ).removeClass('mobile-error-show');


    // ==========================================
    // GET ALL FIELDS
    // ==========================================

    var agencyField = $form.find('#agency-id');

    var motifField = $form.find('#motif-id');

    var fnameField = $form.find('input[name="fname"]');

    var lnameField = $form.find('input[name="lname"]');

    var phoneField = $form.find('.custom_mobile_fileds');

    var emailField = $form.find('input[name="email"]');

    var addressField = $form.find('#search_input');

    var address = $.trim(addressField.val() || '');

    var dateField = $form.find('#datepic_client_date');

    var dateFieldsecond = $form.find('#second_datepic_client_date');

    var timeField = $form.find("select[name='client_time']");

    var privacyField = $form.find('input[name="privacy_policy"]');


    // ==========================================
    // GET VALUES
    // ==========================================

    var agency = $.trim(agencyField.val() || '');

    var motif = $.trim(motifField.val() || '');

    var fname = $.trim(fnameField.val() || '');

    var lname = $.trim(lnameField.val() || '');

    var email = $.trim(emailField.val() || '');

    var dateofbith = $.trim(dateField.val() || '');

    var dateofbithsecond = $.trim(dateFieldsecond.val() || '');

    var meeting_time = $.trim(timeField.val() || '');


    // ==========================================
    // NAME REGEX
    // ==========================================

    var nameRegex = /^[A-Za-zÀ-ÿ]+([ '\-][A-Za-zÀ-ÿ]+)*$/;


    // ==========================================
    // VALIDATION
    // ==========================================

    var hasError = false;

    var firstErrorField = null;


    // 1. AGENCY
    if (agencyField.length && !agency) {

        $form
            .find('.agency-error-message')
            .text('This field is required.')
            .show();

        hasError = true;

        if (!firstErrorField) {
            firstErrorField = agencyField;
        }
    }


    // 2. MOTIF
    if (motifField.length && !motif) {

        $form
            .find('.motif-error-message')
            .text('This field is required.')
            .show();

        hasError = true;

        if (!firstErrorField) {
            firstErrorField = motifField;
        }
    }


    // 3. FIRST NAME
    if (fname === '' || !nameRegex.test(fname)) {

        $form
            .find('.name-error-message')
            .text('Please enter a valid first name.')
            .show();

        $form
            .find('.name_main-wrapp')
            .addClass('mobile-error-show');

        hasError = true;

        if (!firstErrorField) {
            firstErrorField = fnameField;
        }
    }


    // 4. LAST NAME
    if (lname === '' || !nameRegex.test(lname)) {

        $form
            .find('.lastname-error-message')
            .text('Please enter a valid last name.')
            .show();

        $form
            .find('.lastname_main-wrapp')
            .addClass('mobile-error-show');

        hasError = true;

        if (!firstErrorField) {
            firstErrorField = lnameField;
        }
    }


    // 5. PHONE
    var phoneResult = validatePhoneInput($form);

    if (!phoneResult.valid) {

        $form
            .find('.contact-error-message')
            .text('Please enter a valid phone number (e.g. 07700 900123).')
            .show();

        $form
            .find('.mobile_label_input')
            .addClass('mobile-error-show');

        hasError = true;

        if (!firstErrorField) {
            firstErrorField = phoneField;
        }
    }


    // 6. EMAIL
    if (
        !email ||
        email.indexOf('@') === -1 ||
        email.indexOf('.') === -1
    ) {

        $form
            .find('.email-error-message')
            .text('Enter a valid email address.')
            .show();

        hasError = true;

        if (!firstErrorField) {
            firstErrorField = emailField;
        }
    }


    // 7. ADDRESS
    if (addressField.length) {

        if (!address) {

            $form
                .find('.address-error-message')
                .text('Address required')
                .show();

            hasError = true;

            if (!firstErrorField) {
                firstErrorField = addressField;
            }

        } else {

            $form
                .find('.address-error-message')
                .hide();
        }
    }


    // 7. DATE

    // FIRST DATE
    if (dateField.length) {

        if (!dateofbith) {

            $form
                .find('.date_main-wrapp .date-error-message')
                .text('Please enter Date')
                .show();

            $form
                .find('.date_main-wrapp')
                .addClass('mobile-error-show');

            hasError = true;

            if (!firstErrorField) {
                firstErrorField = dateField;
            }
        }
    }


    // SECOND DATE
    if (dateFieldsecond.length) {

        if (!dateofbithsecond) {

            $form
                .find('.date_main-wrappsecond .date-error-message')
                .text('Please enter Date')
                .show();

            $form
                .find('.date_main-wrappsecond')
                .addClass('mobile-error-show');

            hasError = true;

            if (!firstErrorField) {
                firstErrorField = dateFieldsecond;
            }
        }
    }


    // 8. TIME
    if (!meeting_time || meeting_time === 'Heure') {

        $form
            .find('.time-error-message')
            .text('Please select time')
            .show();

        $form
            .find('.time_main-wrapp')
            .addClass('mobile-error-show');

        hasError = true;

        if (!firstErrorField) {
            firstErrorField = timeField;
        }
    }


    // 9. PRIVACY POLICY
    if (privacyField.length && !privacyField.is(':checked')) {

        $form
            .find('.privacy-error-message')
            .text('Please accept the privacy policy.')
            .show();

        hasError = true;

        if (!firstErrorField) {
            firstErrorField = privacyField;
        }
    }


    // ==========================================
    // STOP IF ANY VALIDATION ERROR
    // ==========================================

    console.log("=================================");
    console.log("🔎 VALIDATION RESULT");
    console.log("hasError:", hasError);
    console.log("First error field:", firstErrorField);
    console.log("=================================");


    if (hasError) {

        console.error("❌ FORM STOPPED BY VALIDATION");

        if (firstErrorField && firstErrorField.length) {

            console.log(
                "First invalid field:",
                firstErrorField.attr("name"),
                firstErrorField.attr("id")
            );

            firstErrorField[0].focus();
        }

        return false;
    }


    console.log("✅ ALL VALIDATION PASSED");


    // ==========================================
    // AGENCY HOLIDAY CHECK
    // ==========================================

    var agencyName = "";

    var data_handle =
        $form
            .parents(".tab_data_main")
            .attr("data-handle");

    if (data_handle == "En agence") {

        agencyName =
            $form
                .find("#agency-id option:selected")
                .val();
    }


    let agencyFound = false;

    agencyClosures.forEach(function(row, index) {

        if (!row["Agence"]) {
            return;
        }

        const excelAgency =
            row["Agence"]
                .toString()
                .trim()
                .toLowerCase();

        const selectedAgency =
            agencyName
                .toString()
                .trim()
                .toLowerCase();

        if (excelAgency === selectedAgency) {
            agencyFound = true;
        }

    });


    console.log("==================================");


    var holiday = isAgencyClosed(agencyName, dateofbith);

    if (holiday.status) {

        alert(
            "This agency is closed from " +
            $.datepicker.formatDate("dd/mm/yy", holiday.close) +
            " to " +
            $.datepicker.formatDate("dd/mm/yy", holiday.reopen)
        );

        return false;
    }


    // ==========================================
    // HIDE ERRORS BEFORE SUBMIT
    // ==========================================

    $form.find(".contact-error-message").hide();

    $form.find(".mobile_label_input").removeClass("mobile-error-show");

    $form.find(".date-error-message").hide();

    $form.find(".date_main-wrapp").removeClass("mobile-error-show");

    $form.find(".time-error-message").hide();

    $form.find(".time_main-wrapp").removeClass("mobile-error-show");


    // ==========================================
    // SUBMIT
    // ==========================================

    /*
     * Only lock the button belonging to this form.
     * This prevents double clicks and duplicate appointments.
     */

    $submitButton
        .attr("data-booking-submitting", "true")
        .attr("disabled", true)
        .html("Appointment confirmed ...");


    let formAction =
        "https://goldunion.codevibez.com/api/contact";


    let formEl = document.querySelector(formSelector);

    var formData = new FormData(formEl);


    var object = {

        country_code:
            $form
                .find(".iti__selected-dial-code")
                .html() || '',

        shop:
            "goldunion-uk.myshopify.com"
    };


    formData.forEach(function(value, key) {

        object[key] = value;

    });

    // Send normalized E.164 number and matching dial code
    // (must stay AFTER the forEach so the raw typed value does not overwrite it)
    object.contact      = phoneResult.e164;   // e.g. +447700900123
    object.country_code = phoneResult.dial;   // e.g. +44


    var json = JSON.stringify(object);


    console.log("=================================");
    console.log("🚀 ABOUT TO SEND API REQUEST");
    console.log("API URL:", formAction);
    console.log("Form selector:", formSelector);
    console.log("Date:", object.client_date);
    console.log("Time:", object.client_time);
    console.log("Full payload:", object);
    console.log("JSON payload:", json);
    console.log("=================================");


    fetch(formAction, {

        method: "POST",

        headers: {
            "Content-Type": "application/json"
        },

        body: json

    })

    .then(function(response) {

        console.log("=================================");
        console.log("📡 API RESPONSE RECEIVED");
        console.log("Status:", response.status);
        console.log("OK:", response.ok);
        console.log("=================================");

        return response.text();

    })

    .then(function(responseText) {

        console.log("📦 API RESPONSE:", responseText);

        var result = {};

        if (responseText) {

            try {

                result = JSON.parse(responseText);

            } catch (e) {

                console.error("❌ Invalid JSON response:", e);
            }
        }

        console.log("API RESULT:", result);


        // ==========================================
        // SUCCESS
        // ==========================================

        if (
            result.status === "success" ||
            result.status === "ok"
        ) {

            console.log("✅ FORM SUCCESS");

            /*
             * Mark this booking as successfully submitted.
             * DO NOT remove disabled here.
             */

            $submitButton
                .removeAttr("data-booking-submitting")
                .attr("data-booking-submitted", "true")
                .attr("disabled", true)
                .html("Confirm my appointment");


            $form
                .find(".note--success")
                .addClass("success")
                .removeClass("error")
                .html(
                    "Thank you for contacting us. We will get back to you as soon as possible."
                )
                .show();

            return;
        }


        // ==========================================
        // API ERROR
        // ==========================================

        if (result.status === "error") {

            console.error("❌ API ERROR:", result);

            /*
             * API rejected the booking.
             * Allow customer to try again.
             */

            $submitButton
                .removeAttr("data-booking-submitting")
                .removeAttr("disabled")
                .html("Confirm my appointment");


            $form
                .find(".note--success")
                .addClass("error")
                .removeClass("success")
                .html(
                    result.message ||
                    "Something went wrong. Please try again."
                )
                .show();

            return;
        }


        // ==========================================
        // UNEXPECTED RESPONSE
        // ==========================================

        console.warn("⚠️ Unexpected API response:", result);

        /*
         * Since the booking was not confirmed,
         * allow another attempt.
         */

        $submitButton
            .removeAttr("data-booking-submitting")
            .removeAttr("disabled")
            .html("Confirm my appointment");

    })


    .catch(function(error) {

        console.error("❌ FETCH ERROR:", error);

        /*
         * Network/server error.
         * Booking was not confirmed, so unlock
         * the button and allow retry.
         */

        $submitButton
            .removeAttr("data-booking-submitting")
            .removeAttr("disabled")
            .html("Confirm my appointment");

    });


    return false;
}

// function sendContactFormAction(formSelector) {

//     console.log("=================================");
//     console.log("🟢 SUBMIT BUTTON CLICKED");
//     console.log("Form selector:", formSelector);
//     console.log("=================================");


//     var $form = $(formSelector);

//     /*
//      * =========================================================
//      * CURRENT FORM SUBMIT BUTTON
//      * =========================================================
//      *
//      * IMPORTANT:
//      * Do not use:
//      *
//      * $(".brn-contact-form-submit")
//      *
//      * because that can affect buttons in other forms.
//      *
//      * We only lock the button belonging to this form.
//      */

//     var $submitButton =
//         $form.find(".brn-contact-form-submit");


//     /*
//      * =========================================================
//      * PREVENT DUPLICATE SUBMISSION
//      * =========================================================
//      */

//     // Already successfully submitted
//     if (
//         $submitButton.attr("data-booking-submitted") === "true"
//     ) {

//         console.log(
//             "⚠️ Booking already submitted. Stopping duplicate submission."
//         );

//         return false;
//     }


//     // API request already running
//     if (
//         $submitButton.attr("data-booking-submitting") === "true"
//     ) {

//         console.log(
//             "⚠️ Booking submission already in progress."
//         );

//         return false;
//     }


//     var form = $form[0];


//     // ==========================================
//     // HIDE ALL CUSTOM ERROR MESSAGES
//     // ==========================================

//     $form.find(
//         '.agency-error-message, ' +
//         '.motif-error-message, ' +
//         '.name-error-message, ' +
//         '.lastname-error-message, ' +
//         '.email-error-message, ' +
//         '.contact-error-message, ' +
//         '.address-error-message, ' +
//         '.date-error-message, ' +
//         '.time-error-message, ' +
//         '.privacy-error-message'
//     ).hide();


//     $form.find(
//         '.name_main-wrapp, ' +
//         '.lastname_main-wrapp, ' +
//         '.mobile_label_input, ' +
//         '.date_main-wrapp, ' +
//         '.date_main-wrappsecond, ' +
//         '.time_main-wrapp'
//     ).removeClass('mobile-error-show');


//     // ==========================================
//     // GET ALL FIELDS
//     // ==========================================

//     var agencyField =
//         $form.find('#agency-id');

//     var motifField =
//         $form.find('#motif-id');


//     var fnameField =
//         $form.find('input[name="fname"]');

//     var lnameField =
//         $form.find('input[name="lname"]');


//     var phoneField =
//         $form.find('.custom_mobile_fileds');

//     var emailField =
//         $form.find('input[name="email"]');


//     var addressField =
//         $form.find('#search_input');

//     var address =
//         $.trim(addressField.val() || '');


//     var dateField =
//         $form.find('#datepic_client_date');

//     var dateFieldsecond =
//         $form.find('#second_datepic_client_date');

//     var timeField =
//         $form.find("select[name='client_time']");


//     var privacyField =
//         $form.find('input[name="privacy_policy"]');


//     // ==========================================
//     // GET VALUES
//     // ==========================================

//     var agency =
//         $.trim(agencyField.val() || '');

//     var motif =
//         $.trim(motifField.val() || '');


//     var fname =
//         $.trim(fnameField.val() || '');

//     var lname =
//         $.trim(lnameField.val() || '');


//     var phone =
//         $.trim(phoneField.val() || '');

//     var email =
//         $.trim(emailField.val() || '');


//     var dateofbith =
//         $.trim(dateField.val() || '');

//     var dateofbithsecond =
//         $.trim(dateFieldsecond.val() || '');

//     var meeting_time =
//         $.trim(timeField.val() || '');


//     // ==========================================
//     // NAME REGEX
//     // ==========================================

//     var nameRegex =
//         /^[A-Za-zÀ-ÿ]+([ '\-][A-Za-zÀ-ÿ]+)*$/;


//     // ==========================================
//     // VALIDATION
//     //
//     // FORM ORDER:
//     //
//     // 1. Agency
//     // 2. Motif
//     // 3. First name
//     // 4. Last name
//     // 5. Phone
//     // 6. Email
//     // 7. Date
//     // 8. Time
//     // 9. Privacy
//     // ==========================================

//     var hasError = false;

//     var firstErrorField = null;


//     // ------------------------------------------
//     // 1. AGENCY
//     // ------------------------------------------

//     if (agencyField.length && !agency) {

//         $form
//             .find('.agency-error-message')
//             .text('This field is required.')
//             .show();

//         hasError = true;

//         if (!firstErrorField) {
//             firstErrorField = agencyField;
//         }
//     }


//     // ------------------------------------------
//     // 2. MOTIF
//     // ------------------------------------------

//     if (motifField.length && !motif) {

//         $form
//             .find('.motif-error-message')
//             .text('This field is required.')
//             .show();

//         hasError = true;

//         if (!firstErrorField) {
//             firstErrorField = motifField;
//         }
//     }


//     // ------------------------------------------
//     // 3. FIRST NAME
//     // ------------------------------------------

//     if (
//         fname === '' ||
//         !nameRegex.test(fname)
//     ) {

//         $form
//             .find('.name-error-message')
//             .text('Please enter a valid first name.')
//             .show();


//         $form
//             .find('.name_main-wrapp')
//             .addClass('mobile-error-show');


//         hasError = true;


//         if (!firstErrorField) {
//             firstErrorField = fnameField;
//         }
//     }


//     // ------------------------------------------
//     // 4. LAST NAME
//     // ------------------------------------------

//     if (
//         lname === '' ||
//         !nameRegex.test(lname)
//     ) {

//         $form
//             .find('.lastname-error-message')
//             .text('Please enter a valid last name.')
//             .show();


//         $form
//             .find('.lastname_main-wrapp')
//             .addClass('mobile-error-show');


//         hasError = true;


//         if (!firstErrorField) {
//             firstErrorField = lnameField;
//         }
//     }


//     // ------------------------------------------
//     // 5. PHONE
//     // ------------------------------------------

//     if (!validatePhoneNumber(phone)) {

//         $form
//             .find('.contact-error-message')
//             .text('Please enter valid phone number')
//             .show();


//         $form
//             .find('.mobile_label_input')
//             .addClass('mobile-error-show');


//         hasError = true;


//         if (!firstErrorField) {
//             firstErrorField = phoneField;
//         }
//     }


//     // ------------------------------------------
//     // 6. EMAIL
//     // ------------------------------------------

//     if (
//         !email ||
//         email.indexOf('@') === -1 ||
//         email.indexOf('.') === -1
//     ) {

//         $form
//             .find('.email-error-message')
//             .text('Enter a valid email address.')
//             .show();


//         hasError = true;


//         if (!firstErrorField) {
//             firstErrorField = emailField;
//         }
//     }


//     // ------------------------------------------
//     // 7. ADDRESS
//     // ------------------------------------------

//     if (addressField.length) {

//         if (!address) {

//             $form
//                 .find('.address-error-message')
//                 .text('Address required')
//                 .show();


//             hasError = true;


//             if (!firstErrorField) {
//                 firstErrorField = addressField;
//             }

//         } else {

//             $form
//                 .find('.address-error-message')
//                 .hide();

//         }
//     }


//     // ------------------------------------------
//     // 7. DATE
//     // ------------------------------------------

//     // FIRST DATE

//     if (dateField.length) {

//         if (!dateofbith) {

//             $form
//                 .find('.date_main-wrapp .date-error-message')
//                 .text('Please enter Date')
//                 .show();


//             $form
//                 .find('.date_main-wrapp')
//                 .addClass('mobile-error-show');


//             hasError = true;


//             if (!firstErrorField) {
//                 firstErrorField = dateField;
//             }
//         }
//     }


//     // SECOND DATE

//     if (dateFieldsecond.length) {

//         if (!dateofbithsecond) {

//             $form
//                 .find('.date_main-wrappsecond .date-error-message')
//                 .text('Please enter Date')
//                 .show();


//             $form
//                 .find('.date_main-wrappsecond')
//                 .addClass('mobile-error-show');


//             hasError = true;


//             if (!firstErrorField) {
//                 firstErrorField = dateFieldsecond;
//             }
//         }
//     }


//     // ------------------------------------------
//     // 8. TIME
//     // ------------------------------------------

//     if (
//         !meeting_time ||
//         meeting_time === 'Heure'
//     ) {

//         $form
//             .find('.time-error-message')
//             .text('Please select time')
//             .show();


//         $form
//             .find('.time_main-wrapp')
//             .addClass('mobile-error-show');


//         hasError = true;


//         if (!firstErrorField) {
//             firstErrorField = timeField;
//         }
//     }


//     // ------------------------------------------
//     // 9. PRIVACY POLICY
//     // ------------------------------------------

//     if (
//         privacyField.length &&
//         !privacyField.is(':checked')
//     ) {

//         $form
//             .find('.privacy-error-message')
//             .text('Please accept the privacy policy.')
//             .show();


//         hasError = true;


//         if (!firstErrorField) {
//             firstErrorField = privacyField;
//         }
//     }


//     // ==========================================
//     // STOP IF ANY VALIDATION ERROR
//     // ==========================================

//     console.log("=================================");
//     console.log("🔎 VALIDATION RESULT");
//     console.log("hasError:", hasError);
//     console.log("First error field:", firstErrorField);
//     console.log("=================================");


//     if (hasError) {

//         console.error(
//             "❌ FORM STOPPED BY VALIDATION"
//         );


//         if (
//             firstErrorField &&
//             firstErrorField.length
//         ) {

//             console.log(
//                 "First invalid field:",
//                 firstErrorField.attr("name"),
//                 firstErrorField.attr("id")
//             );


//             firstErrorField[0].focus();
//         }


//         return false;
//     }


//     console.log("✅ ALL VALIDATION PASSED");


//     // ==========================================
//     // AGENCY HOLIDAY CHECK
//     // ==========================================

//     var agencyName = "";


//     var data_handle =
//         $form
//             .parents(".tab_data_main")
//             .attr("data-handle");


//     if (data_handle == "En agence") {

//         agencyName =
//             $form
//                 .find("#agency-id option:selected")
//                 .val();
//     }


//     let agencyFound = false;


//     agencyClosures.forEach(function(row, index) {

//         if (!row["Agence"]) {
//             return;
//         }


//         const excelAgency =
//             row["Agence"]
//                 .toString()
//                 .trim()
//                 .toLowerCase();


//         const selectedAgency =
//             agencyName
//                 .toString()
//                 .trim()
//                 .toLowerCase();


//         if (
//             excelAgency === selectedAgency
//         ) {

//             agencyFound = true;
//         }

//     });


//     console.log("==================================");


//     var holiday =
//         isAgencyClosed(
//             agencyName,
//             dateofbith
//         );


//     if (holiday.status) {

//         alert(
//             "This agency is closed from " +

//             $.datepicker.formatDate(
//                 "dd/mm/yy",
//                 holiday.close
//             ) +

//             " to " +

//             $.datepicker.formatDate(
//                 "dd/mm/yy",
//                 holiday.reopen
//             )
//         );


//         return false;
//     }


//     // ==========================================
//     // HIDE ERRORS BEFORE SUBMIT
//     // ==========================================

//     $form
//         .find(".contact-error-message")
//         .hide();


//     $form
//         .find(".mobile_label_input")
//         .removeClass("mobile-error-show");


//     $form
//         .find(".date-error-message")
//         .hide();


//     $form
//         .find(".date_main-wrapp")
//         .removeClass("mobile-error-show");


//     $form
//         .find(".time-error-message")
//         .hide();


//     $form
//         .find(".time_main-wrapp")
//         .removeClass("mobile-error-show");


//     // ==========================================
//     // SUBMIT
//     // ==========================================

//     /*
//      * IMPORTANT:
//      * Only lock the button belonging to this form.
//      *
//      * This prevents double clicks and duplicate
//      * appointment submissions.
//      */

//     $submitButton
//         .attr("data-booking-submitting", "true")
//         .attr("disabled", true)
//         .html("Appointment confirmed ...");


//     let formAction =
//         "https://goldunion.codevibez.com/api/contact";


//     let formEl =
//         document.querySelector(formSelector);


//     var formData =
//         new FormData(formEl);


//     var object = {

//         country_code:
//             $form
//                 .find(".iti__selected-dial-code")
//                 .html() || '',

//         shop:
//             "goldunion-uk.myshopify.com"
//     };


//     formData.forEach(function(value, key) {

//         object[key] = value;

//     });


//     var json =
//         JSON.stringify(object);


//     console.log("=================================");
//     console.log("🚀 ABOUT TO SEND API REQUEST");
//     console.log("API URL:", formAction);
//     console.log("Form selector:", formSelector);
//     console.log("Date:", object.client_date);
//     console.log("Time:", object.client_time);
//     console.log("Full payload:", object);
//     console.log("JSON payload:", json);
//     console.log("=================================");


//     fetch(formAction, {

//         method: "POST",

//         headers: {
//             "Content-Type": "application/json"
//         },

//         body: json

//     })

//     .then(function(response) {

//         console.log("=================================");
//         console.log("📡 API RESPONSE RECEIVED");
//         console.log("Status:", response.status);
//         console.log("OK:", response.ok);
//         console.log("=================================");


//         return response.text();

//     })

//     .then(function(responseText) {

//         console.log(
//             "📦 API RESPONSE:",
//             responseText
//         );


//         var result = {};


//         if (responseText) {

//             try {

//                 result =
//                     JSON.parse(responseText);

//             } catch (e) {

//                 console.error(
//                     "❌ Invalid JSON response:",
//                     e
//                 );
//             }
//         }


//         console.log(
//             "API RESULT:",
//             result
//         );


//         // ==========================================
//         // SUCCESS
//         // ==========================================

//         if (
//             result.status === "success" ||
//             result.status === "ok"
//         ) {

//             console.log(
//                 "✅ FORM SUCCESS"
//             );


//             /*
//              * Mark this booking as successfully
//              * submitted.
//              *
//              * DO NOT remove disabled here.
//              * This prevents another click.
//              */

//             $submitButton
//                 .removeAttr(
//                     "data-booking-submitting"
//                 )
//                 .attr(
//                     "data-booking-submitted",
//                     "true"
//                 )
//                 .attr(
//                     "disabled",
//                     true
//                 )
//                 .html(
//                     "Confirm my appointment"
//                 );


//             $form
//                 .find(".note--success")
//                 .addClass("success")
//                 .removeClass("error")
//                 .html(
//                     "Thank you for contacting us. We will get back to you as soon as possible."
//                 )
//                 .show();


//             return;
//         }


//         // ==========================================
//         // API ERROR
//         // ==========================================

//         if (
//             result.status === "error"
//         ) {

//             console.error(
//                 "❌ API ERROR:",
//                 result
//             );


//             /*
//              * API rejected the booking.
//              *
//              * Allow customer to try again.
//              */

//             $submitButton
//                 .removeAttr(
//                     "data-booking-submitting"
//                 )
//                 .removeAttr(
//                     "disabled"
//                 )
//                 .html(
//                     "Confirm my appointment"
//                 );


//             $form
//                 .find(".note--success")
//                 .addClass("error")
//                 .removeClass("success")
//                 .html(
//                     result.message ||
//                     "Something went wrong. Please try again."
//                 )
//                 .show();


//             return;
//         }


//         // ==========================================
//         // UNEXPECTED RESPONSE
//         // ==========================================

//         console.warn(
//             "⚠️ Unexpected API response:",
//             result
//         );


//         /*
//          * Since the booking was not confirmed,
//          * allow another attempt.
//          */

//         $submitButton
//             .removeAttr(
//                 "data-booking-submitting"
//             )
//             .removeAttr(
//                 "disabled"
//             )
//             .html(
//                 "Confirm my appointment"
//             );

//     })


//     .catch(function(error) {

//         console.error(
//             "❌ FETCH ERROR:",
//             error
//         );


//         /*
//          * Network/server error.
//          *
//          * Booking was not confirmed, so unlock
//          * the button and allow retry.
//          */

//         $submitButton
//             .removeAttr(
//                 "data-booking-submitting"
//             )
//             .removeAttr(
//                 "disabled"
//             )
//             .html(
//                 "Confirmer mon rendez-vous"
//             );

//     });


//     return false;
// }

// function sendContactFormAction(formSelector) {
//     console.log("=================================");
//     console.log("🟢 SUBMIT BUTTON CLICKED");
//     console.log("Form selector:", formSelector);
//     console.log("=================================");
//     var form = $(formSelector)[0];

//     // ==========================================
//     // HIDE ALL CUSTOM ERROR MESSAGES
//     // ==========================================

//                 $(formSelector).find(
//                     '.agency-error-message, ' +
//                     '.motif-error-message, ' +
//                     '.name-error-message, ' +
//                     '.lastname-error-message, ' +
//                     '.email-error-message, ' +
//                     '.contact-error-message, ' +
//                     '.address-error-message, ' +
//                     '.date-error-message, ' +
//                     '.time-error-message, ' +
//                     '.privacy-error-message'
//                 ).hide();

//         $(formSelector).find(
//             '.name_main-wrapp, ' +
//             '.lastname_main-wrapp, ' +
//             '.mobile_label_input, ' +
//             '.date_main-wrapp, ' +
//             '.date_main-wrappsecond, ' +
//             '.time_main-wrapp'
//         ).removeClass('mobile-error-show');


//     // ==========================================
//     // GET ALL FIELDS
//     // ==========================================

//     var agencyField = $(formSelector).find('#agency-id');
//     var motifField = $(formSelector).find('#motif-id');

//     var fnameField = $(formSelector).find('input[name="fname"]');
//     var lnameField = $(formSelector).find('input[name="lname"]');

//     var phoneField = $(formSelector).find('.custom_mobile_fileds');
//     var emailField = $(formSelector).find('input[name="email"]');

//     var addressField = $(formSelector).find('#search_input');
//     var address = $.trim(addressField.val() || '');

//     var dateField = $(formSelector).find('#datepic_client_date');
//     var dateFieldsecond = $(formSelector).find('#second_datepic_client_date');
//     var timeField = $(formSelector).find("select[name='client_time']");

//     var privacyField = $(formSelector).find('input[name="privacy_policy"]');


//     // ==========================================
//     // GET VALUES
//     // ==========================================

//     var agency = $.trim(agencyField.val() || '');
//     var motif = $.trim(motifField.val() || '');

//     var fname = $.trim(fnameField.val() || '');
//     var lname = $.trim(lnameField.val() || '');

//     var phone = $.trim(phoneField.val() || '');
//     var email = $.trim(emailField.val() || '');

//     var dateofbith = $.trim(dateField.val() || '');
//     var dateofbithsecond = $.trim(dateFieldsecond.val() || '');
//     var meeting_time = $.trim(timeField.val() || '');


//     // ==========================================
//     // NAME REGEX
//     // ==========================================

//     var nameRegex = /^[A-Za-zÀ-ÿ]+([ '\-][A-Za-zÀ-ÿ]+)*$/;


//     // ==========================================
//     // VALIDATION
//     // FORM ORDER:
//     //
//     // 1. Agency
//     // 2. Motif
//     // 3. First name
//     // 4. Last name
//     // 5. Phone
//     // 6. Email
//     // 7. Date
//     // 8. Time
//     // 9. Privacy
//     // ==========================================

//     var hasError = false;
//     var firstErrorField = null;


//     // ------------------------------------------
//     // 1. AGENCY
//     // ------------------------------------------

//     if (agencyField.length && !agency) {

//         $(formSelector)
//             .find('.agency-error-message')
//             .text('This field is required.')
//             .show();

//         hasError = true;

//         if (!firstErrorField) {
//             firstErrorField = agencyField;
//         }
//     }


//     // ------------------------------------------
//     // 2. MOTIF
//     // ------------------------------------------

//     if (motifField.length && !motif) {

//         $(formSelector)
//             .find('.motif-error-message')
//             .text('This field is required.')
//             .show();

//         hasError = true;

//         if (!firstErrorField) {
//             firstErrorField = motifField;
//         }
//     }


//     // ------------------------------------------
//     // 3. FIRST NAME
//     // ------------------------------------------

//     if (fname === '' || !nameRegex.test(fname)) {

//         $(formSelector)
//             .find('.name-error-message')
//             .text('Please enter a valid first name.')
//             .show();

//         $(formSelector)
//             .find('.name_main-wrapp')
//             .addClass('mobile-error-show');

//         hasError = true;

//         if (!firstErrorField) {
//             firstErrorField = fnameField;
//         }
//     }


//     // ------------------------------------------
//     // 4. LAST NAME
//     // ------------------------------------------

//     if (lname === '' || !nameRegex.test(lname)) {

//         $(formSelector)
//             .find('.lastname-error-message')
//             .text('Please enter a valid last name.')
//             .show();

//         $(formSelector)
//             .find('.lastname_main-wrapp')
//             .addClass('mobile-error-show');

//         hasError = true;

//         if (!firstErrorField) {
//             firstErrorField = lnameField;
//         }
//     }


//     // ------------------------------------------
//     // 5. PHONE
//     // ------------------------------------------

//     if (!validatePhoneNumber(phone)) {

//         $(formSelector)
//             .find('.contact-error-message')
//             .text('Please enter valid phone number')
//             .show();

//         $(formSelector)
//             .find('.mobile_label_input')
//             .addClass('mobile-error-show');

//         hasError = true;

//         if (!firstErrorField) {
//             firstErrorField = phoneField;
//         }
//     }


//     // ------------------------------------------
//     // 6. EMAIL
//     // ------------------------------------------

//     if (
//         !email ||
//         email.indexOf('@') === -1 ||
//         email.indexOf('.') === -1
//     ) {

//         $(formSelector)
//             .find('.email-error-message')
//             .text('Enter a valid email address.')
//             .show();

//         hasError = true;

//         if (!firstErrorField) {
//             firstErrorField = emailField;
//         }
//     }

//     /// ------------------------------------------
//             // 7. ADDRESS
//             // ------------------------------------------

//             if (addressField.length) {

//                 if (!address) {

//                     $(formSelector)
//                         .find('.address-error-message')
//                         .text('Address required')
//                         .show();

//                     hasError = true;

//                     if (!firstErrorField) {
//                         firstErrorField = addressField;
//                     }

//                 } else {

//                     $(formSelector)
//                         .find('.address-error-message')
//                         .hide();
//                 }
//             }

//     // ------------------------------------------
//     // 7. DATE
//     // ------------------------------------------

//            // ------------------------------------------
//                 // FIRST DATE
//                 // ------------------------------------------

//                 if (dateField.length) {

//                     if (!dateofbith) {

//                         $(formSelector)
//                             .find('.date_main-wrapp .date-error-message')
//                             .text('Please enter Date')
//                             .show();

//                         $(formSelector)
//                             .find('.date_main-wrapp')
//                             .addClass('mobile-error-show');

//                         hasError = true;

//                         if (!firstErrorField) {
//                             firstErrorField = dateField;
//                         }
//                     }
//                 }


//                 // ------------------------------------------
//                 // SECOND DATE
//                 // ------------------------------------------

//                 if (dateFieldsecond.length) {

//                     if (!dateofbithsecond) {

//                         $(formSelector)
//                             .find('.date_main-wrappsecond .date-error-message')
//                             .text('Please enter Date')
//                             .show();

//                         $(formSelector)
//                             .find('.date_main-wrappsecond')
//                             .addClass('mobile-error-show');

//                         hasError = true;

//                         if (!firstErrorField) {
//                             firstErrorField = dateFieldsecond;
//                         }
//                     }
//                 }


//     // ------------------------------------------
//     // 8. TIME
//     // ------------------------------------------

//     if (!meeting_time || meeting_time === 'Heure') {

//         $(formSelector)
//             .find('.time-error-message')
//             .text('Please select time')
//             .show();

//         $(formSelector)
//             .find('.time_main-wrapp')
//             .addClass('mobile-error-show');

//         hasError = true;

//         if (!firstErrorField) {
//             firstErrorField = timeField;
//         }
//     }


//     // ------------------------------------------
//     // 9. PRIVACY POLICY
//     // ------------------------------------------
//         // ------------------------------------------
//         // PRIVACY POLICY
//         // ------------------------------------------

//         if (
//             privacyField.length &&
//             !privacyField.is(':checked')
//         ) {

//             $(formSelector)
//                 .find('.privacy-error-message')
//                 .text('Please accept the privacy policy.')
//                 .show();

//             hasError = true;

//             if (!firstErrorField) {
//                 firstErrorField = privacyField;
//             }
//         }


//     // ==========================================
//     // STOP IF ANY VALIDATION ERROR
//     // ==========================================

//             console.log("=================================");
//             console.log("🔎 VALIDATION RESULT");
//             console.log("hasError:", hasError);
//             console.log("First error field:", firstErrorField);
//             console.log("=================================");

//             if (hasError) {

//                 console.error("❌ FORM STOPPED BY VALIDATION");

//                 if (firstErrorField && firstErrorField.length) {
//                     console.log(
//                         "First invalid field:",
//                         firstErrorField.attr("name"),
//                         firstErrorField.attr("id")
//                     );

//                     firstErrorField[0].focus();
//                 }

//                 return false;
//             }

//             console.log("✅ ALL VALIDATION PASSED");


//     // ==========================================
//     // AGENCY HOLIDAY CHECK
//     // ==========================================

//     var agencyName = "";
//     var data_handle = $(formSelector)
//         .parents(".tab_data_main")
//         .attr("data-handle");

//     if (data_handle == "En agence") {
//         agencyName = $(formSelector)
//             .find("#agency-id option:selected")
//             .val();
//     }


//     let agencyFound = false;

//     agencyClosures.forEach(function (row, index) {

//         if (!row["Agence"]) return;

//         const excelAgency = row["Agence"]
//             .toString()
//             .trim()
//             .toLowerCase();

//         const selectedAgency = agencyName
//             .toString()
//             .trim()
//             .toLowerCase();

//         if (excelAgency === selectedAgency) {
//             agencyFound = true;
//         }
//     });


//     console.log("==================================");

//     var holiday = isAgencyClosed(
//         agencyName,
//         dateofbith
//     );


//     if (holiday.status) {

//         alert(
//             "This agency is closed from " +
//             $.datepicker.formatDate(
//                 "dd/mm/yy",
//                 holiday.close
//             ) +
//             " to " +
//             $.datepicker.formatDate(
//                 "dd/mm/yy",
//                 holiday.reopen
//             )
//         );

//         return false;
//     }


//     // ==========================================
//     // HIDE ERRORS BEFORE SUBMIT
//     // ==========================================

//     $(formSelector)
//         .find(".contact-error-message")
//         .hide();

//     $(formSelector)
//         .find(".mobile_label_input")
//         .removeClass("mobile-error-show");

//     $(formSelector)
//         .find(".date-error-message")
//         .hide();

//     $(formSelector)
//         .find(".date_main-wrapp")
//         .removeClass("mobile-error-show");

//     $(formSelector)
//         .find(".time-error-message")
//         .hide();

//     $(formSelector)
//         .find(".time_main-wrapp")
//         .removeClass("mobile-error-show");


//     // ==========================================
//     // SUBMIT
//     // ==========================================

//     $(".brn-contact-form-submit")
//         .attr("disabled", true)
//         .html("Appointment confirmed ...");


//     let formAction =
//         "https://goldunion.codevibez.com/api/contact";

//     let formEl = document.querySelector(formSelector);

//     var formData = new FormData(formEl);

//     var object = {
//         country_code: $(formSelector + " .iti__selected-dial-code").html(),
//         shop: "gold-union-shop.myshopify.com",
//     };


//     formData.forEach((value, key) => {
//         object[key] = value;
//     });



//             var json = JSON.stringify(object);

//             console.log("=================================");
//             console.log("🚀 ABOUT TO SEND API REQUEST");
//             console.log("API URL:", formAction);
//             console.log("Form selector:", formSelector);
//             console.log("Date:", object.client_date);
//             console.log("Time:", object.client_time);
//             console.log("Full payload:", object);
//             console.log("JSON payload:", json);
//             console.log("=================================");

//             fetch(formAction, {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 body: json
//             })
//             .then(function(response) {

//                 console.log("=================================");
//                 console.log("📡 API RESPONSE RECEIVED");
//                 console.log("Status:", response.status);
//                 console.log("OK:", response.ok);
//                 console.log("=================================");

//                 return response.text();
//             })
//             .then(function(responseText) {

//                 console.log("📦 API RESPONSE:", responseText);

//                 var result = {};

//                 if (responseText) {
//                     try {
//                         result = JSON.parse(responseText);
//                     } catch (e) {
//                         console.error("❌ Invalid JSON response:", e);
//                     }
//                 }

//                 console.log("API RESULT:", result);


//                 // Re-enable current form button
//                 $(formSelector)
//                     .find(".brn-contact-form-submit")
//                     .removeAttr("disabled")
//                     .html("Confirm my appointment");


//                 // SUCCESS
//                 if (result.status === "success" || result.status === "ok") {

//                     console.log("✅ FORM SUCCESS");

//                     $(formSelector)
//                         .find(".note--success")
//                         .addClass("success")
//                         .removeClass("error")
//                         .html(
//                             "Thank you for contacting us. We will get back to you as soon as possible."
//                         )
//                         .show();

//                     return;
//                 }


//                 // API ERROR
//                 if (result.status === "error") {

//                     console.error("❌ API ERROR:", result);

//                     $(formSelector)
//                         .find(".note--success")
//                         .addClass("error")
//                         .removeClass("success")
//                         .html(
//                             result.message || "Something went wrong. Please try again."
//                         )
//                         .show();

//                     return;
//                 }

//                 console.warn("⚠️ Unexpected API response:", result);

//             })
//             .catch(function(error) {

//                 console.error("❌ FETCH ERROR:", error);

//                 $(formSelector)
//                     .find(".brn-contact-form-submit")
//                     .removeAttr("disabled")
//                     .html("Confirmer mon rendez-vous");

//             });


//     return false;
// }

// ============================================
// GOOGLE MAPS AUTOCOMPLETE
// ============================================
var searchInput = "search_input";
$(document).ready(function () {
    var autocomplete;
    autocomplete = new google.maps.places.Autocomplete(document.getElementById(searchInput), {
        types: ["geocode"],
        componentRestrictions: { country: "fr" },
    });
    google.maps.event.addListener(autocomplete, "place_changed", function () {
        var near_place = autocomplete.getPlace();
        if (document.getElementById("loc_lat")) {
            document.getElementById("loc_lat").value = near_place.geometry.location.lat();
        }
        if (document.getElementById("loc_long")) {
            document.getElementById("loc_long").value = near_place.geometry.location.lng();
        }
        if (document.getElementById("latitude_view")) {
            document.getElementById("latitude_view").innerHTML = near_place.geometry.location.lat();
        }
        if (document.getElementById("longitude_view")) {
            document.getElementById("longitude_view").innerHTML = near_place.geometry.location.lng();
        }
    });
});
$(document).on("change", "#" + searchInput, function () {
    if (document.getElementById("latitude_input")) {
        document.getElementById("latitude_input").value = "";
    }
    if (document.getElementById("longitude_input")) {
        document.getElementById("longitude_input").value = "";
    }
    if (document.getElementById("latitude_view")) {
        document.getElementById("latitude_view").innerHTML = "";
    }
    if (document.getElementById("longitude_view")) {
        document.getElementById("longitude_view").innerHTML = "";
    }
});
// ============================================
// SHIPPING AND ACCORDION HANDLERS
// ============================================
$(document).on("change", ".shipping-line-item--radio input[type='radio']", function () {
    $(".agent-dropdown").hide();
    if ($(this).data("agent") == true) {
        $(this).parents(".shipping-line-item--radio").find(".agent-dropdown").show();
    }
});
$(document).on("click", ".accordion-section-wrapper-main .custom_accordion-btn", function () {
    $(this).parents(".accordion-section-wrapper-main").find(".accordion-section-content_last").slideToggle();
});